import React, { ReactNode } from 'react';
import './DemoBanners.css';

// Purely decorative, static preview section — only an optional block between both rows.
// Verbatim port of the "demo banners" block from the v18 prototype
// (html_templates/prototipo_carga_header_v18.html), shown between Hero and Footer.
const featured = (
  <>
    <h2 className='demo-banners-title'>Propuestas destacadas</h2>
    <div className='demo-banner-grid horizontal'>
      <article className='demo-banner-card horizontal-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>Oferta destacada</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-line short' />
          <div className='demo-banner-price' />
        </div>
      </article>
      <article className='demo-banner-card horizontal-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>Salida confirmada</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-line short' />
          <div className='demo-banner-price' />
        </div>
      </article>
      <article className='demo-banner-card horizontal-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>Cupos limitados</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-line short' />
          <div className='demo-banner-price' />
        </div>
      </article>
    </div>
  </>
);

const national = (
  <>
    <h2 className='demo-banners-title'>Experiencias nacionales</h2>
    <div className='demo-banner-grid vertical'>
      <article className='demo-banner-card vertical-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>12 cuotas</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-price' />
        </div>
      </article>
      <article className='demo-banner-card vertical-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>Todo el año</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-price' />
        </div>
      </article>
      <article className='demo-banner-card vertical-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>Escapada</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-price' />
        </div>
      </article>
      <article className='demo-banner-card vertical-card'>
        <div className='demo-banner-image'>
          <span className='demo-banner-chip'>Promoción</span>
        </div>
        <div className='demo-banner-body'>
          <div className='demo-banner-line title' />
          <div className='demo-banner-line medium' />
          <div className='demo-banner-price' />
        </div>
      </article>
    </div>
  </>
);

interface DemoBannersProps {
  content?: ReactNode;
}

const DemoBanners: React.FC<DemoBannersProps> = ({ content }) =>
  content ? (
    <>
      <main aria-label='Banners demostrativos' className='demo-banners' id='demoBanners'>
        <div className='demo-banners-inner'>{featured}</div>
      </main>
      {content}
      <section aria-label='Banners demostrativos' className='demo-banners'>
        <div className='demo-banners-inner'>{national}</div>
      </section>
    </>
  ) : (
    <main aria-label='Banners demostrativos' className='demo-banners' id='demoBanners'>
      <div className='demo-banners-inner'>
        {featured}
        {national}
      </div>
    </main>
  );

export default DemoBanners;
